// IMPORTS
import Vue from 'vue'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import store from './store'
import router from './router'
import App from './App'

// SETUP PLUGINS
Vue.config.productionTip = false
console.log('Backend URL: ' + process.env.VUE_APP_BACKENDURL)

new Vue({
  store,
  router,
  vuetify,
  el: '#app',
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js